export default "__VITE_ASSET__Ddc1eQWc__"